import { EpicPolicy } from './tower/Domain';


export interface DocumentV2 {
  id: number
  year?: number
  documentCategory: string
  documentTypeID: number
  documentType: string
  accountId: number
  accountName: string
  parentAccountId?: number
  policyId?: number
  policyNumber?: string
  expiresAt?: string
  carrier?: string
  carrierId?: number
  coverageType?: string
  fileName?: string
  displayName?: string 
  createdBy?: string
  createdAt?: string
  lastModifiedBy?: string
  lastModifiedAt?: string
  published: boolean
}

export interface DocumentPublishRequest {
  category: string;
  id: number;
}

export interface DocumentFile {
  filename: string
  createdBy: string
  createdAt: string
  lastModifiedAt: string
  lastModifiedBy: string
}

export interface DocumentType {
  id: number
  name: string
  scope: 'account' | 'policy'
}

export interface DocumentFileUpload {
  filename: string 
  data: File
  type: DocumentType
}

export interface PolicyDocumentFileUpload extends DocumentFileUpload {
  type: DocumentType
}

export interface UploadResponse {
  success: boolean
  messages: string[]
}

export interface PolicyFileMap {
  policy: EpicPolicy
  file: File
  type: DocumentType
}

export enum PolicyDocumentType {
    POLICY = 1,
    QUOTE = 3,
    SUBMISSION = 4,
    CLIENT_PRESENTATION = 5,
    OTHER = 6,
    BOND = 7,
    RIDER = 8,
    CONTINUATION_CERTIFICATE = 9,
    VERIFICATION_CERTIFICATE = 10,
    ENDORSEMENT = 11,
    CERTIFICATE = 12,
    SURETY_TRADE_CREDIT = 13
}

export enum DocumentDomain {
  ACCOUNT = "Account",
  POLICY = "Policy",
  ANALYTICS = "Analytics",
  REPORTING = "Reporting", // TODO: maybe remove this in the future
}

